enum BarrelType {
    PROJECT = "project",
    STYLEGUIDE = "styleguide"
}

export default BarrelType;
